/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import { LockIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/account-settings';

const styles = {
  container: css`
    gap: var(--cds-spacing-200);
  `,
  icon: css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: var(--cds-color-emphasis-primary-background-xweak);
  `,
  content: css`
    > *:not(:first-child) {
      margin-block-start: var(--cds-spacing-100);
    }
  `,
};

type Props = { ssoOrgName: string | undefined };

const SSOAccountLoginInformation = ({ ssoOrgName }: Props) => {
  return (
    <Grid container wrap="nowrap" alignItems="center" css={styles.container}>
      <Grid>
        <div css={styles.icon}>
          <LockIcon />
        </div>
      </Grid>
      <Grid css={styles.content}>
        <Typography2 component="h3" variant="subtitleLarge">
          {_t('Your log-in method is Single sign-on')}
        </Typography2>

        <Typography2 component="p" variant="bodySecondary">
          {ssoOrgName
            ? _t(
                `Your email is managed by #{OrgName}'s authentication provider and can’t be changed directly in Coursera.`,
                {
                  OrgName: ssoOrgName,
                }
              )
            : _t(
                `Your email is managed by your organization's authentication provider and can’t be changed directly in Coursera.`
              )}
        </Typography2>
      </Grid>
    </Grid>
  );
};

export default SSOAccountLoginInformation;
